import { Message, MetaConversation } from 'lib-shared-legacy-types';

/**
 * Trustpilotreview channel conceptually contains only review and a reply. If
 * there is only one conversation:message_added type message - it means there is
 * only review and no reply yet and the return result will be null. Otherwise
 * this function returns the last reply.
 *
 * @param metaConversation
 * @returns {Message | null} - Last message reply if exist
 */
export const getLastReviewReply = ({
  conversation,
  messages,
}: MetaConversation): Message | null => {
  if (conversation.initial_channel !== 'trustpilotreviews') {
    return null;
  }

  const filteredMessages = messages.filter(
    ({ type }) => type === 'conversation:message_added',
  );

  return filteredMessages.length > 1 ? filteredMessages.at(-1) ?? null : null;
};
